import * as d3 from 'd3'

export default {
  methods: {
    
    draw_Toolbar() {

      let toolBarCanvas = this.canvasTooolBar
      .append('g')
      .attr('id',`TOOLBAR`)
      .attr('transform', `translate(${this.header.x}, ${this.header.y-18})`)

      this.draw_NewWorkOrder(toolBarCanvas) // -----> below
      this.draw_Department(toolBarCanvas) // -----> below
      this.filtering_Options(toolBarCanvas) // -----> below
      this.filtering_TimePeriod(toolBarCanvas)
      this.draw_Status(toolBarCanvas) // -----> below
    },


    draw_NewWorkOrder(selection) {

      let nweWO = selection
      .append('g')
      .attr('id', `NEW_WO`)
      .attr('transform', `translate(0, 0)`)
      .attr('cursor', 'pointer').attr('opacity', 1)
      .call(this.call_NewWorkOrder)

      let _width = 90
      nweWO
      .append('rect')
      .attr('x', 0).attr('y', -17).attr('rx', 3)
      .attr('width', _width).attr('height', 32)
      .attr('stroke', '#bcbcbc').attr('stroke-width', 0.5)
      .attr('fill', `url(#${this.localId}_LightBlue_)`)
      .attr('opacity', .5) 
      
      nweWO
      .append('text')
      .attr('x', _width/2).attr('y', 3)
      .attr('font-size', 11).attr('text-anchor', 'middle')
      .attr('fill', '#000')
      .text(`+ New WO`)

    },


    draw_Department(selection) {

      let deptCanvas = selection
      .append('g')
      .attr('transform', `translate(${100.5}, -17)`)

      deptCanvas
      .append('rect')
      .attr('x', 0).attr('y', 0)
      .attr('width', 136).attr('height', 32)
      .attr('stroke', '#bcbcbc').attr('stroke-width', 0.5)
      .attr('fill', 'none').attr('opacity', .5)

      this.gmx_Text(deptCanvas, ``, 0, -2,  9, '#333','', '', 'Department')

      this.toolBar.department.forEach((d,i)=> {

        let item = deptCanvas
        .append('g')
        .attr('id',`DEPT_${i}`)
        .attr('transform', `translate(${i*40+(5+i*3)}, 1)`)
        .attr('cursor', 'pointer').attr('opacity', 1)
        .call(this.call_Department, d)

        item
        .append('rect')
        .attr('id', `DEPT_RECT_${i}`)
        .attr('rx', 3).attr('y', 3)
        .attr('width', 40).attr('height', 24)
        .attr('stroke', '#bcbcbc').attr('stroke-width', 0.5)
        .attr('fill', d.checked ? '#E1F5FF' : `url(#${this.localId}_LightGray_)`)
        .attr('opacity', .5) 

        item
        .append('image')
        .attr('id', `DEPT_SVG_${i}`)
        .attr('xlink:href', this.HOST + `/WorkOrder/icons/${d.file}.svg`)
        .attr('x', 10).attr('y', 6).attr('height', 18)
        .attr('opacity', d.checked ? 1 : .5)

      })
    },


    filtering_Options(selection) {

      let filters = selection
      .append('g')
      .attr('id', `FILTER_GROUP`)
      .attr('transform', `translate(${246.5}, -17)`)
      
      filters
      .append('rect')
      .attr('x', 0).attr('y', 0)
      .attr('width', 136).attr('height', 32)
      .attr('stroke', '#bcbcbc').attr('stroke-width', 0.5)
      .attr('fill', 'none').attr('opacity', .5)

      this.gmx_Text(filters, ``, 0, -2,  9, '#333','', '', 'Status of MenuItem')

      this.toolBar.filtering.forEach((d,i)=> {
        let item = filters
        .append('g')
        .attr('id',`FILTER_${i}`)
        .attr('transform', `translate(${i*40+(5+i*3)}, 0)`)
        .attr('cursor', 'pointer').attr('opacity', 1)
        .call(this.call_Filtering, d, i)

        item
        .append('rect')
        .attr('id', `FILTER_RECT_${i}`)
        .attr('rx', 3).attr('y', 4)
        .attr('width', 40).attr('height', 24)
        .attr('stroke', '#bcbcbc').attr('stroke-width', 0.5)
        .attr('fill', d.checked ? '#E1F5FF' : `url(#${this.localId}_LightGray_)`)
        .attr('opacity', .5) 

        item
        .append('image')
        .attr('id', `FILTER_SVG_${i}`)
        .attr('xlink:href', this.HOST + `/WorkOrder/icons/${d.file}.svg`)
        .attr('x', 10).attr('y', 5).attr('height', 21)
        .attr('opacity', d.checked ? 1 : .5)
      })

    },


    filtering_TimePeriod(selection) {
   
      let duration = selection
      .append('g')
      .attr('transform', `translate(${391.5}, -17)`)

      duration
      .append('rect')
      .attr('x', 0).attr('y', 0)
      .attr('width', 140).attr('height', 32)
      .attr('stroke', '#bcbcbc').attr('stroke-width', 0.5)
      .attr('fill', 'none').attr('opacity', .5) 
      
      this.gmx_Text(duration, ``, 0, -2,  9, '#333','', '', 'Number of Months to Show')

      this.toolBar.timePeriod.forEach((d,i)=> {
        let monthNo = duration
        .append('g')
        .attr('transform', `translate(${i*35}, 16)`).attr('opacity', 1)
        .call(this.call_TimePeriod, d, i)

        monthNo
        .append('circle')
        .attr('id', `PERIOD_CIRCLE_${i}`)
        .attr('cx', 17).attr('cy', 0)
        .attr('r', 10).attr('fill', d.checked ? '#E1F5FF' : `url(#${this.localId}_LightGray_)`)
        .attr('stroke', '#bcbcbc').attr('stroke-width', .5)

        monthNo
        .append('text')
        .attr('id', `PERIOD_TEXT_${i}`)
        .attr('x', 17).attr('y', 3.5)
        .attr('font-size', 11).attr('text-anchor', 'middle')
        .attr('fill', d.checked ? '#000' : '#757575')
        .text(d.month * -1)
      })
    },


    draw_Status(selection) {

      let legend = selection
      .append('g')
      .attr('id',`STATUS`)
      .attr('transform', `translate(${this.header.length}, 0)`)

      let _x = 0
      this.status.forEach(d=> {

        let status = legend
        .append('g')
        .attr('id',`${d.id}`)
        .attr('transform', `translate(${_x}, 0)`)

        status
        .append('rect')
        .attr('width', 9).attr('height', 9)
        .attr('rx', 1).attr('ry', 1).attr('stroke', d.stroke).attr('stroke-width', .5).attr('fill', d.color)

        this.gmx_Text(status, ``, 13, 8,  10, '#333','start', '', d.name)

        _x = _x + this.getNode(`#${d.id}`) + 15
      })

      d3.select(`#STATUS`).attr('transform', `translate(${this.header.length-this.getNode(`#STATUS`)}, ${this.header.y-115})`)
    },


    update_Toolbar() {

      this.toolBar.department.forEach((d,i)=> {
        d3.select(`#DEPT_RECT_${i}`).attr('fill', d.checked ? '#E1F5FF' : `url(#${this.localId}_LightGray_)`)
        d3.select(`#DEPT_SVG_${i}`).attr('opacity', d.checked ? 1 : .5)
      })

      this.toolBar.filtering.forEach((d,i)=> {
        d3.select(`#FILTER_RECT_${i}`).attr('fill', d.checked ? '#E1F5FF' : `url(#${this.localId}_LightGray_)`)
        d3.select(`#FILTER_SVG_${i}`).attr('opacity', d.checked ? 1 : .5)
      })

      this.toolBar.timePeriod.forEach((d,i)=> {
        d3.select(`#PERIOD_CIRCLE_${i}`).attr('fill', d.checked ? '#E1F5FF' : `url(#${this.localId}_LightGray_)`)
        d3.select(`#PERIOD_TEXT_${i}`).attr('fill', d.checked ? '#000' : '#757575')
      })
    },
 

  }
}
